<template>
  <tr>
    <!--<td>{{dirty ? '(*)' : ''}}</td>-->
    <td>{{seller.sellerKey.value}}</td>
    <td>{{seller.region}}</td>
    <td><input v-model="name" required="true" maxlength="70" class="ui input focus" /></td>
    <td>{{authToken}}</td>
    <td v-if="showAdvertisementApiSettings">
      <center v-if="seller.connectedToAdvertisementApi"><i class="check circle outline icon"></i></center>
      <center v-else>
        <button type="button" class="ui icon button" v-on:click="redirectToAdvertisementAuthPage" data-tooltip="Authorize SentryKit to access Advertisement data">
          <i class="plug icon"></i>
        </button>
      </center>
    </td>
    <td class="one wide" v-if="anyAccountMayNeedReAuthorization" >
      <div data-tooltip="May Need Re-Authorization">
        <i class="exclamation triangle icon" v-if="seller.mayNeedReauthorization"></i>
      </div>
    </td>
    <td class="one wide">
        <button type="button" class="ui icon button" v-on:click="reauthorize()" data-tooltip="Re-Authorize">
          <i class="linkify icon"></i>
        </button>
    </td>
    <td class="one wide" v-if="isOwner">
      <button type="button" class="ui icon button" v-on:click="requestDeleteAccount()" data-tooltip="Delete Account">
        <i class="trash alternate outline icon"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import $ from 'jquery'
import { amazonAuthorizationQueryMarketplace } from '../../utils/amazonSellingPartnerOAuth'

export default {
  data: function () {
    return {
      dirty: false,
      editAuthToken: false,
      name: this.seller.nickName,
      authToken: '****' + this.seller.authTokenLast6Digit,
      hasNoAccess: false,
    }
  },
  props: ['seller', 'showAdvertisementApiSettings', 'anyAccountMayNeedReAuthorization', 'isOwner'],
  methods: {
    toJson: function () {
      return {
        sellerId: this.seller.sellerId,
        name: this.isNameDirty() ? this.name : null,
        mwsAuthToken: this.isAuthTokenDirty() ? this.authToken : null,
      }
    },
    requestDeleteAccount: function () {
      const el = $('#deleteSellerAccountModal')
      el.modal({ onApprove: this.deleteAccount })
      el.modal('show')
    },
    deleteAccount: function () {
      this.$http.delete('/api/v1/sellers/' + this.seller.sellerId.value).then((response) => {
        this.$emit('sellerAccountDeleted', this.seller.sellerId.value)
      }, (response) => {
        this.error = response.body.error + ': ' + response.body.message
      })
    },
    isNameDirty: function () {
      return this.name !== this.seller.nickName
    },
    isAuthTokenDirty: function () {
      return this.authToken !== '******' + this.seller.authTokenLast6Digit
    },
    checkIfDirty: function () {
      const dirty = this.dirty
      this.dirty = this.isNameDirty() || this.isAuthTokenDirty()
      if (dirty !== this.dirty) this.$emit('account-changed')
    },
    redirectToAdvertisementAuthPage: function () {
      window.location = ('https://www.amazon.com/ap/oa?client_id=amzn1.application-oa2-client.938fa2b8ac364f26a3a3fbf100505b53&scope=cpc_advertising:campaign_management&response_type=code&redirect_uri=' +
        encodeURIComponent(window.location.origin) + '%2Ft0%2Fidentity%2Fadconnect&state=' + this.seller.sellerId.value)
    },
    reauthorize: function () {
      const data = {
        region: this.seller.region,
        marketplace: amazonAuthorizationQueryMarketplace(this.seller.region, this.seller.marketplaceId || this.seller.marketplace_id),
        path: this.$route.path,
        accName: this.name,
        expectedSellerKey: this.seller.sellerKey.value,
      }
      this.$http.get('/api/identity/amazon/authorization/redirect', {params: data}).then((response) => {
        window.location = response.body.location
      }, (response) => {
        window.alert(response.body.message)
      })
    }
  },
  watch: {
    seller: {
      handler: function (val) {
        this.editAuthToken = false
        this.authToken = '******' + val.authTokenLast6Digit
        this.checkIfDirty()
      },
      deep: true,
    },
    name: function () {
      this.checkIfDirty()
    },
    authToken: function () {
      this.checkIfDirty()
    },
  }
}
</script>



// WEBPACK FOOTER //
// SellerAccount.vue?3af8e636